import { Link } from "@/components/LocalLink";
import { productById, formatShort, productPath, IMAGES } from "@/data/catalog";
import { PageShell, usePageMeta } from "@/components/PageShell";
import { BuyButton } from "@/components/BuyButton";

const CARE = [
  ["Pace", "Let them set it. The sniff is the point of the walk, not the distance."],
  ["Rest", "Senior dogs sleep like they mean it. Guard the nap as they once guarded the door."],
  ["Routine", "Same measure, same hour, same bowl. Predictability is a kindness."],
  ["Attention", "Note the small changes. You know this dog better than any instrument we own."],
];

export default function SeniorDogs() {
  const p = productById("grey_muzzle_reserve");
  usePageMeta("Senior dogs · Dirty Paws Apothecary", "For older dogs, and the ones getting there. The Gray Muzzle Reserve: lion's mane, set aside for the elders of the pack.");
  return (
    <PageShell testid="senior-page" page="senior">
      <div className="wrap">
        <div className="sh">
          <div>
            <div className="eyebrow">For the gray muzzles</div>
            <h1>For older dogs, and the ones getting there.</h1>
            <p>When the walk shortens and the sleep deepens. One jar set aside for the elders of the pack, plus what we've learned living with ours.</p>
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
              <Link to={productPath(p)} className="btn btn-primary" data-testid="senior-shop-reserve">Shop the Reserve · $72</Link>
              <Link to="/find-your-jar" className="btn btn-ghost" data-testid="senior-quiz">Find your dog's jar</Link>
            </div>
          </div>
          <div className="panel prod" data-testid="senior-reserve-card">
            <Link to={productPath(p)}><img src={p.image} alt={`${p.name} jar`} /></Link>
            <div className="b">
              <span className="best">Senior dogs</span>
              <h3>{p.name}</h3><div className="muted" style={{ fontSize: 14 }}>Lion's mane · mushroom powder</div>
              <div className="row"><span className="price">{formatShort(p.priceCents)}</span><span className="muted" style={{ fontSize: 13 }}>60 g · 60 measures</span></div>
              <BuyButton productIds={p.id} className="btn btn-ghost" testid="senior-reserve-add" />
              <div className="ez" data-testid="dog-note">“{p.dogNote.text}” <span className="muted" style={{ fontFamily: "Manrope", fontStyle: "normal", fontSize: 12 }}>· Ezekiel, Chief of Staff · a note from the Founding Four, not a customer review</span></div>
            </div>
          </div>
        </div>
        <div className="care4" data-testid="senior-notes">
          {CARE.map(([h, t], i) => <div key={h}><div className="eyebrow">0{i + 1}</div><h4>{h}</h4><p>{t}</p></div>)}
        </div>
        <div className="vet" data-testid="senior-word">
          <img src={IMAGES.field} alt="Three of the founding dogs running down a field path" style={{ objectPosition: "50% 60%" }} />
          <div><div className="eyebrow">Before you start</div><h2 className="sec">A word on older dogs</h2>
            <ul>
              <li><b>Ask your vet first</b> if your dog is unwell or on medication. Older dogs often are.</li>
              <li><b>Start with the measure for their weight.</b> A 60 lb senior gets three quarters a day; the jar lasts 80 days.</li>
              <li><b>Not sure it's for them?</b> <Link to="/products/discovery-dram" style={{ color: "var(--brass)" }}>The Discovery Dram</Link> is a two-week trial for $29.</li>
            </ul>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
